export const getThemeFixedColors = (token: Record<string, string>) => {
  const themeConstants: Record<string, string> = {};
  Object.entries(token).forEach(([key, value]) => {
    themeConstants[`${key}Fixed`] = value;
  });

  return themeConstants;
};

export const setCssEnvFromObject = (cssVars: Record<string, string>) => {
  try {
    const root = document.documentElement;
    for (const key in cssVars) {
      root.style.setProperty(`--${key}`, cssVars[key]);
    }
  } catch (e) {
    console.error(`failed fetching theme with error: ${e}`);
  }
};
